<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'empty'
}
</script>

<style scoped></style>
